module.exports = __webpack_public_path__ + "img/logo.b4e856c2.png";